import { render, staticRenderFns } from "./siderFiltersCastingCalls.vue?vue&type=template&id=5783e2d0&scoped=true&"
import script from "./siderFiltersCastingCalls.vue?vue&type=script&lang=js&"
export * from "./siderFiltersCastingCalls.vue?vue&type=script&lang=js&"
import style0 from "./siderFiltersCastingCalls.vue?vue&type=style&index=0&id=5783e2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783e2d0",
  null
  
)

export default component.exports